const cachedScripts = [];

const loadScript = src => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    if (cachedScripts.includes(src)) {
      return resolve();
    }

    script.src = src;
    script.async = true;
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      cachedScripts.push(src);
      resolve();
    });
    script.addEventListener('error', reject);
  });
};

export default loadScript;
